// extracted by mini-css-extract-plugin
module.exports = {"address":"booking-site-address-module--address--R-Pj7","loading":"booking-site-address-module--loading--89bC7","addressBody":"booking-site-address-module--addressBody--1-Wrl"};